<template>
  <div class="service-item row q-mb-xs">
    <div class="col-6">
      <div class="flex items-center">
        <span class="col ellipsis">
          {{ item?.name }}
        </span>
        <PTooltip
          v-if="item?.description"
          :offset="[8, 6]"
          anchor="center left"
          self="center right"
        >
          {{ item?.description }}
        </PTooltip>
        <PBtn
          v-if="item?.is_removable && !viewMode"
          class="q-ml-xs"
          dense
          flat
          round
          @click="$emit('remove')"
        >
          <RemoveIcon class="icon--xs" />
        </PBtn>
      </div>
    </div>
    <div class="col-6">
      <div class="text-right">
        {{
          numberFormat({
            number: item?.amount,
            style: "currency",
          })
        }}
      </div>
    </div>
  </div>
</template>

<script setup>
import RemoveIcon from "assets/icons/remove.svg";

import { numberFormat } from "assets/scripts/utilities/helpers";

defineEmits(["remove"]);

defineProps({
  item: {
    type: Object,
    default: () => {
      return {};
    },
  },

  viewMode: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.service-item {
  * {
    min-height: 24px;
  }

  .q-btn {
    display: none;
  }

  &:hover {
    .q-btn {
      display: inline-flex;
    }
  }
}
</style>
